
import { ICellRendererParams } from 'ag-grid-community/dist/lib/rendering/cellRenderers/iCellRenderer';
import { Component, Vue } from 'vue-property-decorator';
import CheckBox from './CheckBox.vue';
@Component({ components: { CheckBox } })
export default class CheckBoxCellEditor extends Vue {
  value = true;
  params!: ICellRendererParams;
  created() {
    this.value = this.params.value;
  }
  onChange() {
    this.value = !this.value;
  }
  getValue() {
    return this.value;
  }
}
